import React, { forwardRef } from 'react';
import ContentEditor from './ContentEditor';

// Wrapper component for backward compatibility
// This component maintains the same API as the original LessonPlanEditor
// but delegates all functionality to the new modular ContentEditor
const LessonPlanEditor = forwardRef(({ data, selectedField, onSectionSelect, selectedSectionForChat }, ref) => {
  return (
    <ContentEditor
      ref={ref}
      content={data.lessonPlan || ''}
      selectedField={selectedField}
      onSectionSelect={onSectionSelect}
      selectedSectionForChat={selectedSectionForChat}
    />
  );
});

export default LessonPlanEditor;
